import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import type { DashSetupModule } from "@mirage/analytics/events/enums/dash_setup_module";
import { PAP_Shown_DashSetupModule } from "@mirage/analytics/events/types/shown_dash_setup_module";
import { useEffect, useRef } from "react";

export const useSetupModuleShown = (
  module: DashSetupModule,
  dismissed: boolean,
) => {
  const { reportPapEvent } = useMirageAnalyticsContext();
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (hasRunRef.current || dismissed) return;
    hasRunRef.current = true;

    reportPapEvent(
      PAP_Shown_DashSetupModule({
        dashActionSurface: "setup_module",
        actionSurfaceComponent: "setup_module",
        featureLine: "onboarding",
        dashSetupModule: module,
      }),
    );
  }, [dismissed, module, reportPapEvent]);
};
